let __undefinedType;
const UndefinedType = __undefinedType = Object.seal({
    fullName: 'undefined',
    name: 'undefined',
    namespace: '',
    baseType: __undefinedType,
    isArray: false,
    factory: () => undefined,
});
export default UndefinedType;
